import { render, staticRenderFns } from "./agreementList.vue?vue&type=template&id=1596bdf4&scoped=true&"
import script from "./agreementList.vue?vue&type=script&lang=js&"
export * from "./agreementList.vue?vue&type=script&lang=js&"
import style0 from "./agreementList.vue?vue&type=style&index=0&id=1596bdf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596bdf4",
  null
  
)

export default component.exports